exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.required-field > label[data-v-cd88df5e]::after , label[data-v-cd88df5e]::after {\n    content: '*';\n    color: red;\n    margin-left: 0.25rem;\n}\n.form-control-feedback[data-v-cd88df5e] {\n    font-weight: 100;\n    color: red;\n    position: initial;\n    text-align: left;\n    height: auto;\n    width: auto;\n}\n.has-danger[data-v-cd88df5e] {\n    color: red\n}\n.swal2-popup[data-v-cd88df5e]{\n    font-size: 2rem !important;\n}\n.gradientbt[data-v-cd88df5e]{\n    background: #0F6940;\n    color: white\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-cd88df5e","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/site/SiteDetail.vue
// module id = 235
// module chunks = 0